import { useEffect, useState } from 'react';
import Spinner from '../../components/common/Spinner';
import linksService from '../../api/services/links.service';
import { showToast } from '../../store/useToastStore';

/* Add/edit class link — the redesign's compact one-row form (name + URL), used on
   the Links page and inside Compose Email. Create posts to the selected network;
   edit updates name/link only. */
export default function LinkForm({ open, editingLink, networkId, onClose, onSaved }) {
  const [label, setLabel] = useState('');
  const [url, setUrl] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setLabel(editingLink ? editingLink.label : '');
    setUrl(editingLink ? editingLink.url : '');
  }, [editingLink, open]);

  const save = async () => {
    if (!label.trim()) { window.alert('Give the link a name.'); return; }
    if (!url.trim()) { window.alert('Add the link URL.'); return; }
    if (!editingLink && !networkId) {
      showToast('Select a class in the header first.');
      return;
    }
    setSaving(true);
    try {
      if (editingLink) {
        await linksService.update({ id: editingLink.id, name: label.trim(), link: url.trim() });
        showToast('Link updated ✓');
      } else {
        await linksService.create({ networkId, name: label.trim(), link: url.trim() });
        showToast('Link added ✓');
      }
      onSaved();
      onClose();
    } catch (err) {
      showToast(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={`inline-form ${open ? 'on' : ''}`}>
      <div className="link-add-row">
        <input
          type="text"
          value={label}
          placeholder="Name — e.g. Shared Photo Album"
          onChange={(e) => setLabel(e.target.value)}
        />
        <input type="text" value={url} placeholder="https://..." onChange={(e) => setUrl(e.target.value)} />
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" disabled={saving} onClick={save}>
          {saving ? <><Spinner /> Saving…</> : editingLink ? 'Save Changes' : 'Save Link'}
        </button>
      </div>
    </div>
  );
}
